<template>
	<div class="how__it_works">
		<tile
			v-for="(point, index) in points"
			:key="index"
			:point="point"
			:title="showTitle"
		></tile>
	</div>
</template>

<script>
import { sortByOrder } from '../../../../js/buyout';
import Tile from '../HowItWorks/Tile';
import {mapActions} from "vuex";
import {VUEX_BUYOUT} from "../../../store/buyout";
import {ACTION_TYPES} from "../../../store/buyout/_action-types";

export default {
	name: 'HowItWorks',
	data() {
		return {
			points: []
		}
	},
	async created() {
		if (!this.points.length) {
			await this.fetchData();
		}
	},
	components: {
		Tile
	},
	props: {
		showTitle: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	methods:{
		...mapActions(VUEX_BUYOUT.NAMESPACE, [
			ACTION_TYPES.LOAD_HOW_IT_WORKS
		]),
		async fetchData(){
			this.points = sortByOrder(await this[ACTION_TYPES.LOAD_HOW_IT_WORKS]());
		},
	},
	watch: {
		"$i18n.locale"() {
			this.fetchData();
		}
	}
}
</script>
